import { AnyObject } from '../../constants/types'
import { ReactComponent as Auto } from '../../icons/points/auto.svg'
import { ReactComponent as Cultural } from '../../icons/points/cultural.svg'
import { ReactComponent as Danger } from '../../icons/points/danger.svg'
import { ReactComponent as Epam } from '../../icons/points/epam.svg'
import { ReactComponent as Finance } from '../../icons/points/finance.svg'
import { ReactComponent as Food } from '../../icons/points/food.svg'
import { ReactComponent as Government } from '../../icons/points/government.svg'
import { ReactComponent as Health } from '../../icons/points/health.svg'
import { ReactComponent as KidsEducation } from '../../icons/points/kids_education.svg'
import { ReactComponent as Leisure } from '../../icons/points/leisure.svg'
import { ReactComponent as Pets } from '../../icons/points/pets.svg'
import { ReactComponent as Realty } from '../../icons/points/realty.svg'
import { ReactComponent as Sport } from '../../icons/points/sport.svg'
import { ReactComponent as Shop } from '../../icons/points/shop.svg'
import { ReactComponent as Utilities } from '../../icons/points/utilities.svg'

export const getPointCardIcon = {
  '1': Sport,
  '4': Leisure,
  '6': Epam,
  '10': Epam,
  '11': Realty,
  '12': Health,
  '13': KidsEducation,
  '14': Pets,
  '15': Government,
  '16': Finance,
  '17': Utilities,
  '18': Food,
  '19': Cultural,
  '20': Auto,
  '21': Danger,
  '76': Shop,
} as AnyObject
